var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTable = function SvgTable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 3.833a.5.5 0 0 0-.5.5v11.334a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5V4.334a.5.5 0 0 0-.5-.5h-13Zm-1.5.5a1.5 1.5 0 0 1 1.5-1.5h13a1.5 1.5 0 0 1 1.5 1.5v11.334a1.5 1.5 0 0 1-1.5 1.5h-13a1.5 1.5 0 0 1-1.5-1.5V4.333Zm3.333 2.334a.5.5 0 0 1 .5-.5H10a.5.5 0 0 1 0 1H5.833a.5.5 0 0 1-.5-.5Zm7.167-.5a.5.5 0 0 0 0 1h1.667a.5.5 0 0 0 0-1H12.5ZM5.333 10a.5.5 0 0 1 .5-.5H10a.5.5 0 0 1 0 1H5.833a.5.5 0 0 1-.5-.5Zm7.167-.5a.5.5 0 0 0 0 1h1.667a.5.5 0 0 0 0-1H12.5Zm-7.167 3.834a.5.5 0 0 1 .5-.5H10a.5.5 0 0 1 0 1H5.833a.5.5 0 0 1-.5-.5Zm7.167-.5a.5.5 0 0 0 0 1h1.667a.5.5 0 0 0 0-1H12.5Z",
    fill: "#818C96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 3.833a.5.5 0 0 0-.5.5v11.334a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5V4.334a.5.5 0 0 0-.5-.5h-13Zm-1.5.5a1.5 1.5 0 0 1 1.5-1.5h13a1.5 1.5 0 0 1 1.5 1.5v11.334a1.5 1.5 0 0 1-1.5 1.5h-13a1.5 1.5 0 0 1-1.5-1.5V4.333Zm3.333 2.334a.5.5 0 0 1 .5-.5H10a.5.5 0 0 1 0 1H5.833a.5.5 0 0 1-.5-.5Zm7.167-.5a.5.5 0 0 0 0 1h1.667a.5.5 0 0 0 0-1H12.5ZM5.333 10a.5.5 0 0 1 .5-.5H10a.5.5 0 0 1 0 1H5.833a.5.5 0 0 1-.5-.5Zm7.167-.5a.5.5 0 0 0 0 1h1.667a.5.5 0 0 0 0-1H12.5Zm-7.167 3.834a.5.5 0 0 1 .5-.5H10a.5.5 0 0 1 0 1H5.833a.5.5 0 0 1-.5-.5Zm7.167-.5a.5.5 0 0 0 0 1h1.667a.5.5 0 0 0 0-1H12.5Z",
    fill: "#747F88"
  })));
};

export default SvgTable;